import { gql, useApolloClient, useQuery } from '@apollo/client';
import {
  GetRecipesQuery,
  GetRecipesQueryVariables,
} from '../../__generated__/queries-recipe';

export const GET_RECIPES = gql`
  query GetRecipes(
    $first: Int!
    $skip: Int
    $orderBy: [RecipeOrderByInput!]
    $where: RecipeWhereInput!
  ) {
    recipeCount(where: $where)
    recipes(first: $first, skip: $skip, orderBy: $orderBy, where: $where) {
      id
      brandKey
      title
      lead
      publishedAt
      medias
      status
      recipeUrls(first: 1, orderBy: position_ASC) {
        url {
          path
        }
      }
    }
  }
`;

export const useGetRecipes = (
  variables: GetRecipesQueryVariables,
  skip?: boolean,
) =>
  useQuery<GetRecipesQuery, GetRecipesQueryVariables>(GET_RECIPES, {
    variables,
    skip,
    notifyOnNetworkStatusChange: true,
  });

export const useGetRecipesPromise = () => {
  const client = useApolloClient();

  return async (variables: GetRecipesQueryVariables) => {
    const { data, errors } = await client.query<
      GetRecipesQuery,
      GetRecipesQueryVariables
    >({
      query: GET_RECIPES,
      variables,
    });

    if (errors?.length) {
      throw errors[0];
    }
    return data?.recipes;
  };
};
